var _rect, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlockedOccupiedMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 21,
    viewBox: "0 0 64 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_38_773",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 63.5,
    y: 20.4105,
    width: 63,
    height: 19,
    rx: 9.5,
    transform: "rotate(-180 63.5 20.4105)",
    fill: "#D9D9D9",
    stroke: "#1CADE4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_38_773)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.5,
    y: 20.4105,
    width: 63,
    height: 19,
    rx: 9.5,
    transform: "rotate(-180 63.5 20.4105)",
    stroke: "#1CADE4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.8699,
    y: 35.3225,
    width: 55.0175,
    height: 48,
    transform: "rotate(-162.746 24.8699 35.3225)",
    fill: "#474B5A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8003 7.20648C21.5341 6.94027 21.1041 6.94027 20.8379 7.20648L17.5 10.5375L14.1621 7.19966C13.8959 6.93345 13.4659 6.93345 13.1997 7.19966C12.9334 7.46587 12.9334 7.8959 13.1997 8.16212L16.5375 11.5L13.1997 14.8379C12.9334 15.1041 12.9334 15.5341 13.1997 15.8003C13.4659 16.0666 13.8959 16.0666 14.1621 15.8003L17.5 12.4625L20.8379 15.8003C21.1041 16.0666 21.5341 16.0666 21.8003 15.8003C22.0666 15.5341 22.0666 15.1041 21.8003 14.8379L18.4625 11.5L21.8003 8.16212C22.0597 7.90273 22.0597 7.46587 21.8003 7.20648Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockedOccupiedMale);
export default __webpack_public_path__ + "static/media/blocked-occupied-male.a6bd44ce75c931bff8b4265480a87504.svg";
export { ForwardRef as ReactComponent };